import React from "react";

export const Money = () => (
  <svg viewBox="0 0 512 512">
    <path
      d="M257.38,0C397.78,0.43,512.29,115.92,512,256.8C511.7,397.89,396.08,512.52,254.59,512
   C114.07,511.48-0.29,396.12,0,255.2C0.29,114.12,115.82-0.43,257.38,0z M248.85,312.82c-15.91-3.53-20.95-14.78-25.21-27.12
   c-4.3-12.47-14.84-16.48-23.73-9.51c-7.48,5.87-7.2,13.69-4.62,21.62c6.6,20.31,21.27,32.43,41.51,36.67
   c10.35,2.17,13.31,6.53,12.21,16.3c-0.79,7.04-0.22,14.26-0.06,21.39c0.09,4.08,2.24,6.79,6.48,7.07c4.4,0.3,6.63-2.52,7.07-6.42
   c0.54-4.71,0.54-9.48,0.63-14.23c0.12-6.34-1.72-13.47,0.61-18.82c2.79-6.42,11.62-4.51,17.62-6.77
   c21.89-8.26,36.38-27.73,35.98-49.57c-0.39-21.66-13.51-38.33-36.41-46.11c-4.11-1.4-8.31-2.56-12.49-3.75
   c-3.28-0.94-5.44-2.28-5.37-6.43c0.24-14.52,0.09-29.05,0.09-44.64c11.13,3.65,16.46,10.51,19.47,20.23
   c2.86,9.23,9.44,14.02,19.2,10.47c9.89-3.59,11.2-11.95,8.11-20.61c-5.7-15.97-16.91-27.14-33.6-30.54
   c-9.55-1.95-15.14-4.37-13.43-15.39c0.68-4.39-1.25-9.22-6.79-9.38c-6.45-0.19-7.79,4.78-7.18,9.9c1.09,9.12-1.8,12.66-11.69,14.24
   c-22.53,3.59-36.9,19.89-38.57,40.58c-1.97,24.34,7.65,39.91,30.49,49.22c4.03,1.64,8.07,3.58,12.29,4.37c5.84,1.1,7.63,4,7.5,9.79
   C248.61,280.81,248.85,296.27,248.85,312.82z"
    />
    <path
      d="M263.16,263.62c0,14.7,0.2,29.27-0.08,43.84c-0.15,7.47,3.58,6.26,8.19,4.55
   c10.76-3.99,18.04-14.77,17.28-25.77C287.69,273.86,279.41,266.29,263.16,263.62z M248.03,227.41c0-15.94,0-30.3,0-44.87
   c-16.24,4.93-20.95,10.23-20.96,22.29C227.05,218.77,236.72,223.25,248.03,227.41z"
    />
    <path
      d="M263.16,263.62c16.25,2.67,24.53,10.24,25.39,22.62c0.76,11-6.52,21.78-17.28,25.77
   c-4.61,1.71-8.34,2.92-8.19-4.55C263.36,292.9,263.16,278.32,263.16,263.62z"
    />
    <path
      d="M248.03,227.41c-11.31-4.16-20.98-8.63-20.96-22.58c0.01-12.06,4.72-17.35,20.96-22.29
   C248.03,197.11,248.03,211.46,248.03,227.41z"
    />
  </svg>
);
